import { Slider, TextField, Typography, useTheme } from "@material-ui/core";
import React from "react";
import Text from "./Text";

export const InputFieldWithSlider = ({
  inputId,
  value,
  fullWidth = true,
  labelTid,
  min,
  max,
  disabled,
  termMarks,
  hintLabel,
  onChange,
  onChangeCommitted,
  InputProps,
  error = false,
}) => {
  const { palette } = useTheme();

  const rangedValue = value < min ? min : value > max ? max : value;

  return (
    <>
      {labelTid && (
        <Typography variant={"subtitle1"} style={{ color: palette.text.title }}>
          <strong>
            <Text tId={labelTid} />
          </strong>
        </Typography>
      )}
      <TextField
        id={inputId}
        disabled={disabled}
        variant="outlined"
        fullWidth={fullWidth}
        error={value !== rangedValue || error}
        value={value}
        onChange={(e) => onChange(e, e.target.value)}
        inputProps={{
          "aria-label": `${labelTid} input field`,
          inputMode: "numeric",
          pattern: "[0-9]*",
        }}
        InputProps={{
          endAdornment: !disabled && (
            <i
              className="icon-edit-input"
              style={{
                pointerEvents: "none",
                opacity: 0.5,
                verticalAlign: "text-top",
                fontSize: "25px",
                color: palette.grey[700],
              }}
            />
          ),
          ...InputProps,
        }}
        style={{ marginBottom: "4px" }}
      />
      {hintLabel && <small className={"float-right"}>{hintLabel}</small>}
      <Slider
        aria-label={`${labelTid} slider`}
        id={inputId}
        value={value}
        onChange={(_, value) => onChange(_, value)}
        onChangeCommitted={
          onChangeCommitted
            ? (_, value) => onChangeCommitted(_, value)
            : undefined
        }
        min={min}
        max={max}
        step={termMarks ? null : 1}
        marks={termMarks}
        disabled={disabled}
      />
    </>
  );
};
